import "./landing/landing.css";
import { LandingPage as LandingV2 } from "./landing/LandingPage";

/**
 * Public marketing homepage (route `/`).
 *
 * Thin wrapper that pulls in the scoped landing stylesheet and renders the
 * self-contained "SIGNAL" landing (see ./landing/). Kept as a separate module
 * so the build-time prerender can import the pure component tree without the
 * CSS side-effect import.
 */
export function LandingPage() {
  return <LandingV2 />;
}

export default LandingPage;
